import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface ChartData {
  year: string;
  Revenue: number;
  EBITDA: number;
  PAT: number;
}

interface FinancialChartProps {
  data: ChartData[];
}

const FinancialChart = ({ data }: FinancialChartProps) => {
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-4 border border-primary-200 rounded-lg shadow-lg">
          <p className="font-semibold text-primary-800 mb-2">{`FY ${label}`}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} className="text-sm" style={{ color: entry.color }}>
              {`${entry.dataKey}: ₹${entry.value.toFixed(2)} Cr`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full h-96 bg-gradient-to-br from-primary-50 to-white rounded-lg border border-primary-200 p-6 hover:shadow-lg transition-shadow duration-300">
     
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#d9cba6" opacity={0.3} />
          <XAxis 
            dataKey="year" 
            stroke="#8b6639"
            fontSize={12}
            tickLine={false}
            axisLine={false}
          />
          <YAxis 
            stroke="#8b6639"
            fontSize={12}
            tickLine={false}
            axisLine={false}
            tickFormatter={(value) => `₹${value}`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend 
            wrapperStyle={{ paddingTop: '20px' }}
            iconType="rect"
          />
          <Bar 
            dataKey="Revenue" 
            fill="#d9cba6" 
            name="Revenue"
            radius={[4, 4, 0, 0]}
            maxBarSize={60}
          />
          <Bar 
            dataKey="EBITDA" 
            fill="#b89565" 
            name="EBITDA"
            radius={[4, 4, 0, 0]}
            maxBarSize={60}
          />
          <Bar 
            dataKey="PAT" 
            fill="#8b6639" 
            name="PAT"
            radius={[4, 4, 0, 0]}
            maxBarSize={60}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FinancialChart;